// Single source of truth for the primary navigation destinations.
// Used by the desktop drawer (TheNavBar.vue), the mobile bottom tab bar
// (Layout/MobileBottomNav.vue), and the mobile home shortcut grid
// (Dashboard/MobileHome.vue) so the three stay in sync.
//
// Each link declares the Role Restrictions `permission` key that reveals it.
// Access is purely hat-based — there is no access_level/role gating here. The
// Sales workspace link carries `sales.agent_workspace`, the key held by the
// Sales Agent hat (it also keeps the `salesAgent` flag so other surfaces can
// recognise it as the agent's home).
export const navLinks = [
  { icon: "mdi-view-dashboard", name: "Dashboard", route: "/", permission: "route.dashboard" },
  { icon: "mdi-account-multiple", name: "Accounts", route: "/accounts", permission: "route.accounts" },
  { icon: "mdi-chart-box", name: "Sales", route: "/sales", salesAgent: true, permission: "sales.agent_workspace" },
  { icon: "mdi-desktop-tower-monitor", name: "Units", route: "/units", permission: "route.units" },
  { icon: "mdi-receipt-text", name: "Invoices", route: "/invoices", permission: "route.invoices" },
  { icon: "mdi-account-clock-outline", name: "AR Aging", route: "/ar_aging", permission: "ar.view_aging_dashboard" },
  { icon: "mdi-invoice-text-clock", name: "Recurring Invoices", route: "/recurring_invoices", permission: "route.recurring_invoices" },
  { icon: "mdi-face-agent", name: "Customer Aftercare", route: "/installed_systems", permission: "route.installed_systems" },
  { icon: "mdi-file-document-outline", name: "Quotations", route: "/quotations", permission: "route.quotations" },
  { icon: "mdi-account-search", name: "Leads", route: "/leads", permission: "route.leads" },
  { icon: "mdi-clipboard-list-outline", name: "Purchase Requests", route: "/internal_purchase_orders", permission: "route.internal_purchase_orders" },
  { icon: "mdi-cart-outline", name: "Government Purchase Orders", route: "/customer_purchase_orders", permission: "route.customer_purchase_orders" },
  { icon: "mdi-truck-delivery-outline", name: "Supplier Purchase Orders", route: "/supplier_purchase_orders", permission: "route.supplier_purchase_orders" },
  { icon: "mdi-package-variant", name: "Inventory Management", route: "/items", permission: "route.items" },
  { icon: "mdi-truck-cargo-container", name: "RMA Items", route: "/rma", permission: "route.rma" },
  { icon: "mdi-tools", name: "Services", route: "/services", permission: "route.services" },
  { icon: "mdi-badge-account-horizontal", name: "Employees and Wages", route: "/employees", permission: "route.employees" },
  { icon: "mdi-cog", name: "Admin Settings", route: "/admin_settings", permission: "route.admin_settings" },
];

// The links a user may actually see, applying the same gating as the desktop
// drawer (TheNavBar.visibleLinks). Pass the auth user + the
// `permission/hasPermission` getter.
export function visibleNavLinks(user, hasPermission) {
  if (!user) return [];
  // A Sales Agent (the `sales.agent_workspace` hat) sees ONLY its own workspace
  // links; everyone else sees whatever their hats grant. Gating is entirely
  // hat-based — no access_level/role checks.
  if (hasPermission("sales.agent_workspace")) {
    return navLinks.filter((l) => l.salesAgent);
  }
  return navLinks.filter((l) => l.permission && hasPermission(l.permission));
}

// Preferred bottom-tab-bar destinations (in order). The bottom bar shows the
// first few of these that the user can access, plus a "More" tab that opens
// the full drawer. `short` is the compact label used under the tab icon.
export const primaryMobileTabs = [
  { route: "/", short: "Home" },
  { route: "/invoices", short: "Invoices" },
  { route: "/units", short: "Units" },
  { route: "/items", short: "Inventory" },
  { route: "/accounts", short: "Accounts" },
];
